import z from "zod";

export const ExperienceSchema = z.object({
  business_name: z.string(),
  role_title: z.string(),
  start_date: z.string(),
  end_date: z.string(),
  role_description: z.string(),
});

export type Experience = z.infer<typeof ExperienceSchema>;

export const ExperienceListResponseSchema = z.object({
  experiences: z.array(ExperienceSchema),
  message: z.string().nullable(),
  success: z.boolean(),
});

export type ExperienceListResponse = z.infer<
  typeof ExperienceListResponseSchema
>;
